import { HostStatus } from '../enums/HostStatus';
import { ScanPlatform } from '../enums/ScanPlatform';

export class Host {
  constructor(
    private readonly id: number,
    private readonly name: string,
    private readonly status: HostStatus,
    private readonly platform: ScanPlatform,
    private readonly statusReason: string,
    private readonly originId: string,
    private readonly reportId: number | null
  ) {}

  getId() {
    return this.id;
  }

  getName() {
    return this.name;
  }

  getStatus() {
    return this.status;
  }

  getPlatform() {
    return this.platform;
  }

  getStatusReason() {
    return this.statusReason;
  }

  getOriginId() {
    return this.originId;
  }

  getReportId() {
    return this.reportId;
  }
}
